import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { Log } from '../../lib/util/CustomUtil';

/**
 * 필수 확인 가이드
 */
const EsReqMustGuideBlock = styled.div`
  .hc-msg {
    /* hard-coded for replacing guide table info */
    font-weight: 700;
    //margin-top:22px;
  }
`;

const EsReqMustGuide = ({ detailInfo }) => {

    // if (detailInfo === null) {
    //     return <EsReqMustGuideBlock />;
    // }
    //
    // if (detailInfo.masterinfo.es_notice_msg === null
    //   || detailInfo.masterinfo.es_notice_msg === "") {
    //
    //     if (detailInfo.masterinfo.is_ladder_car === null
    //       || detailInfo.masterinfo.is_ladder_car === 0) {
    //         return <EsReqMustGuideBlock />;
    //     }
    //
    // }

    const getSuspendMsg = () => {

        if (detailInfo.masterinfo.es_notice_msg !== null
          && detailInfo.masterinfo.es_notice_msg !== "") {
            return (
              <div className="margin_b-20">
                  <div className="font-bold">*{detailInfo.masterinfo.es_notice_label}</div>
                  <div>{detailInfo.masterinfo.es_notice_msg}</div>
              </div>
            );
        }
    }

    const getLadderMsg = () => {
        if (detailInfo.masterinfo.is_ladder_car !== null
          && detailInfo.masterinfo.is_ladder_car === 1) {
            return <div className="margin_b-20 font-bold">* 사다리차 이용 요금은 별도로 진행 합니다.</div>;
        }
    }

    return (
      <EsReqMustGuideBlock>
          <div className="default-table pink-title margin_b-120">
              <h3 className="dt-title">필수 확인 사항</h3>

              <table>
                  <tbody>
                  <tr>
                      <td className="gray">
                          <div className="padding_l-10">
                              {detailInfo&&getSuspendMsg()}
                              {detailInfo&&getLadderMsg()}
                              <div className="hc-msg">* 배송정보, 반품/교환/AS 안내는 각 상품상세를 참조바랍니다.</div>
                          </div>
                      </td>
                  </tr>
                  </tbody>
              </table>
          </div>
      </EsReqMustGuideBlock>
    );
};

export default EsReqMustGuide;
